import { RelayEnvironment } from '@/graphql/relay-env';
import { graphql } from 'react-relay';
import { type PayloadError, commitMutation } from 'relay-runtime';
import { useRelayStore } from '../useRelayStore';
import type {
  Media_CreateMediaItem_Mutation,
  Media_CreateMediaItem_Mutation$data,
  Media_CreateMediaItem_Mutation$variables,
} from './__generated__/Media_CreateMediaItem_Mutation.graphql';
import type {
  Media_UploadVideoPost_Mutation,
  Media_UploadVideoPost_Mutation$data,
  Media_UploadVideoPost_Mutation$variables,
} from './__generated__/Media_UploadVideoPost_Mutation.graphql';

export * from './__generated__/Media_Url_Fragment.graphql';
const MediaItemUrlFragment = graphql`
  fragment Media_Url_Fragment on MediaItem {
    mediaItemUrl
    mediaDetails {
      sizes {
        sourceUrl
        name
      }
    }
  }
`;

export * from './__generated__/Media_CreateMediaItem_Mutation.graphql';
export const CreateMediaItemMutation = graphql`
  mutation Media_CreateMediaItem_Mutation($input: NewMediaItemInput!, $connections: [ID!]!) {
    newMediaItem(input: $input) {
      mediaItem @prependNode(connections: $connections, edgeTypeName: "MediaItem") {
        __id
        id
        ...Media_Url_Fragment @relay(mask: false)
        mimeType
        title
        fileSize
        author {
          ...Frags_With_Author_Fragment @relay(mask: false)
        }
      }
    }
  }
`;

export const createMediaItemMutation = (
  input: Media_CreateMediaItem_Mutation$variables['input'],
  connections: string[] = [],
  onCompleted?: (
    response: Media_CreateMediaItem_Mutation$data | null,
    errors: readonly PayloadError[] | null | undefined
  ) => void
) => {
  const storeConnections = useRelayStore.getState().get__id('Media_Query_Pagination_Fragment');

  commitMutation<Media_CreateMediaItem_Mutation>(RelayEnvironment, {
    mutation: CreateMediaItemMutation,
    uploadables: {
      'input.file': input.file,
    },
    variables: {
      input: {
        ...input,
        file: null,
      },
      connections: [...new Set([...connections, ...storeConnections])],
    },
    onCompleted,
    onError: (error) => {
      onCompleted?.(null, [error]);
    },
  });
};

export * from './__generated__/Media_UploadVideoPost_Mutation.graphql';
export const UploadVideoPostMutation = graphql`
  mutation Media_UploadVideoPost_Mutation($input: UploadVideoPostInput!, $connections: [ID!]!) @raw_response_type {
    uploadVideoPost(input: $input) {
      databaseId
      znglyVideo @prependNode(connections: $connections, edgeTypeName: "ZnglyVideo") {
        ...ZnglyVideo_Pagination_Node_Fragment @relay(mask: false)
      }
    }
  }
`;

export const createVideoPostMutation = (
  vars: Media_UploadVideoPost_Mutation$variables,
  onCompleted?: (
    response: Media_UploadVideoPost_Mutation$data | null,
    errors: readonly PayloadError[] | null | undefined
  ) => void
) => {
  const input = vars.input;

  const uploadables = {} as Record<string, File>;
  input.files?.forEach((file, index) => {
    uploadables[`input.files.${index}`] = file;
  });

  const storeConnections = useRelayStore.getState().get__id('ZnglyVideos_Pagination_Fragment');

  commitMutation<Media_UploadVideoPost_Mutation>(RelayEnvironment, {
    mutation: UploadVideoPostMutation,
    uploadables,
    variables: {
      input: {
        ...input,
        files: input?.files?.map(() => null),
      },
      connections: [...new Set([...storeConnections, ...vars.connections])],
    },
    onCompleted,
    onError: (error) => {
      onCompleted?.(null, [error]);
    },
  });
};
